import { TRADE_TERM } from 'common/envs/constants'
import { capitalize } from 'lodash'
import { useTranslation } from 'react-i18next'
import { AboutAxel } from 'web/components/about-manifold'
import { ExplainerPanel } from 'web/components/explainer-panel'
import { Col } from 'web/components/layout/col'
import { Page } from 'web/components/layout/page'
import { AxelLogo } from 'web/components/nav/manifold-logo'
import { SEO } from 'web/components/SEO'
import { Title } from 'web/components/widgets/title'
import { LabCard } from './lab'
import { Socials } from 'web/components/socials'

export default function AboutPage() {
  const { t } = useTranslation()
  return (
    <Page trackPageView={'about page'} className="!col-span-7">
      <SEO
        title={t('about.seoTitle')}
        description={t('about.seoDescription', { trade: TRADE_TERM })}
      />

      <Col className=" p-4">
        <Title className="hidden sm:flex">{t('about.pageTitle')}</Title>
        <AxelLogo className="mb-4 flex sm:hidden" />
        <Col className="gap-4">
          <div>
            <AboutAxel className="text-lg" />
          </div>

          <ExplainerPanel className={'max-w-full'} showWhatIsAxel={false} />

          <div>
            <h2 className={'text-ink-600 mb-2 text-xl'}>{t('about.introVideo')}</h2>
            <div className="mb-1 text-lg">
              {t('about.introVideoDescription')}
            </div>
            <iframe
              src="https://www.youtube.com/embed/DB5TfX7eaVY?start=9"
              className="mb-4 h-80 w-full max-w-2xl"
            ></iframe>
          </div>

          <div>
            <h2 className={'text-ink-600 mb-2 text-xl'}>{t('about.ourMission')}</h2>
            <div className="mb-1 text-lg">
              <li>
                {t('about.mission1')}
              </li>
              <li>
                {t('about.mission2')}
              </li>
              <li>
                {t('about.mission3')}
              </li>
            </div>
          </div>

          <Socials className="mb-2" />

          <div>
            <h2 className={'text-ink-600 mb-2 text-xl'}>
              {t('about.stillHaveQuestions')}
            </h2>

            <div className="mt-4 grid gap-x-2 md:grid-cols-3">
              <LabCard
                title={t('about.faqTitle')}
                href="https://docs.manifold.markets/faq"
                target="_blank"
                description={t('about.faqDescription')}
              />

              <LabCard
                title={t('about.guidelinesTitle')}
                href="https://manifoldmarkets.notion.site/New-WIP-Community-Guidelines-2b986d33f0c646478d4921667c272f21"
                target="_blank"
                description={t('about.guidelinesDescription')}
              />

              <LabCard
                title={t('about.sitemapTitle')}
                href="/sitemap"
                description={t('about.sitemapDescription')}
              />
            </div>
            <div className="text-lg">
              {t('about.modHelp')}
            </div>
          </div>
        </Col>
      </Col>
    </Page>
  )
}
